<div class="leads-status-container" [class.compact-empty]="totalLeads === 0">
  @if (totalLeads === 0) {
    <p class="empty-state-simple">No lead status info found</p>
  }

  @if (totalLeads !== 0) {
    <div class="dashboard-header">
      <div class="total-leads-info">
        <span class="total-label">Total Leads:</span>
        <span class="total-count">{{ totalLeads }}</span>
      </div>
    </div>
  }

  @if (isExpanded && totalLeads !== 0 && totalLeadsStatus !== 0) {
    <div class="status-cards-wrapper collapse-animation">
      @if (leadStatusCounts$ | async; as statusCounts) {
        @for (statusCount of statusCounts; track statusCount.status) {
          @if (statusCount.count > 0) {
            <a
              href="javascript:void(0);"
              class="status-card"
              [attr.data-status]="statusCount.status"
              (click)="onLeadsStatusClick(statusCount.status)"
            >
              <div class="circular-progress">
                <svg class="progress-ring" width="60" height="60">
                  <circle
                    class="progress-ring-bg"
                    cx="30"
                    cy="30"
                    r="25"
                    fill="transparent"
                    stroke="#e5e7eb"
                    stroke-width="6"
                  ></circle>
                  <circle
                    class="progress-ring-circle"
                    cx="30"
                    cy="30"
                    r="25"
                    fill="transparent"
                    [attr.stroke]="getStatusColor(statusCount.status)"
                    stroke-width="6"
                    stroke-linecap="round"
                    [style.stroke-dasharray]="getCircumference()"
                    [style.stroke-dashoffset]="
                      getStrokeOffset(getPercentage(statusCount.count))
                    "
                  ></circle>
                </svg>
                <div class="progress-content">
                  <div class="progress-count">{{ statusCount.count }}</div>
                  <div class="progress-percentage">
                    {{ getPercentage(statusCount.count) }}%
                  </div>
                </div>
              </div>
              <div class="card-content">
                <div
                  class="status-name"
                  [class]="getStatusColorClass(statusCount.status)"
                >
                  {{
                    statusCount.status === "Not Defined"
                      ? "Not Set"
                      : statusCount.status
                  }}
                </div>
              </div>
            </a>
          }
        }
      } @else {
        <div class="loading-placeholder">
          <div class="skeleton-card"></div>
          <div class="skeleton-card"></div>
          <div class="skeleton-card"></div>
        </div>
      }
    </div>
  }
</div>
